import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { SignUpType, SignUpElement } from "@faire/retailer-visitor-shared/lib/popSignUp";
import { trackSignUpClick } from "@faire/retailer-visitor-shared/lib/popSignUpUtils";
import { getSignUpLink } from "@faire/retailer-visitor-shared/lib/popSignUpUtils";
import { optimizeImageUrl } from "@faire/web--source/common/images/optimizeImages";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { Button } from "@faire/web--source/slate/Button";
import { Lock } from "@faire/web--source/slate/icons/foundation/Lock";
import { Column, Flex, Row } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web--source/slate/Typography";
import { useResponsiveValue } from "@faire/web--source/ui/hooks/useResponsiveValue";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { IImage } from "@faire/web-api--source/indigofair/data/IImage";
import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";
export var LoggedOutCategoryPageHeroBanner = function(param) {
    var layoutElement = param.layoutElement;
    var _layoutElement_background_image = layoutElement.background_image, background_image = _layoutElement_background_image === void 0 ? IImage.build() : _layoutElement_background_image, main_text = layoutElement.main_text, description_text = layoutElement.description_text, background_color = layoutElement.background_color;
    var isSSR = useIsSSR();
    var history = useHistory();
    var imgSrc = useResponsiveValue({
        mobileAndAbove: optimizeImageUrl(background_image, isSSR, {
            width: 454,
            height: 214,
            resizeMethod: "fit"
        }),
        tabletAndAbove: optimizeImageUrl(background_image, isSSR, {
            width: 700,
            height: 325,
            resizeMethod: "fit"
        }),
        desktopAndAbove: optimizeImageUrl(background_image, isSSR, {
            width: 800,
            height: 372,
            resizeMethod: "fit"
        }),
        xxLargeDesktop: optimizeImageUrl(background_image, isSSR, {
            width: 1200,
            height: 558,
            resizeMethod: "fit"
        })
    });
    var handleSignUpClick = function() {
        trackSignUpClick(SignUpType.GENERIC, SignUpElement.TOP_BANNER, "logged_out_category_page_hero_banner");
        history.push(getSignUpLink(SignUpType.GENERIC, history.location));
    };
    return /*#__PURE__*/ _jsxs(Wrapper, {
        $bannerColor: background_color,
        children: [
            /*#__PURE__*/ _jsx(BannerTextWrapper, {
                children: /*#__PURE__*/ _jsxs(ContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: {
                                mobileAndAbove: "pageHeaderSerifRegular",
                                tabletAndAbove: "displaySSerifRegular",
                                xLargeAndAbove: "displayMSerifRegular"
                            },
                            as: "h1",
                            color: Core.text.inverse,
                            children: main_text
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: {
                                mobileAndAbove: "1/2x",
                                tabletAndAbove: "2x"
                            }
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: {
                                mobileAndAbove: "paragraphSansRegular",
                                xLargeAndAbove: "subheadingSansRegular"
                            },
                            color: Core.text.inverse,
                            children: description_text
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            height: "3x"
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            onClick: handleSignUpClick,
                            variant: "secondary",
                            style: {
                                border: "none"
                            },
                            children: /*#__PURE__*/ _jsxs(Row, {
                                align: "center",
                                children: [
                                    /*#__PURE__*/ _jsx(Lock, {
                                        lockType: "foundation",
                                        fontSize: 16
                                    }),
                                    /*#__PURE__*/ _jsx(Spacer, {
                                        width: 4
                                    }),
                                    /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                        id: "YUPe3W",
                                        defaultMessage: [
                                            {
                                                type: 0,
                                                value: "Unlock wholesale pricing"
                                            }
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(BannerImageWrapper, {
                children: /*#__PURE__*/ _jsx(BannerImage, {
                    src: imgSrc,
                    "data-test-id": "banner-image",
                    alt: background_image === null || background_image === void 0 ? void 0 : background_image.alt_text
                })
            })
        ]
    });
};
var Wrapper = styled(Flex).attrs({
    direction: {
        mobileAndAbove: "column-reverse",
        tabletAndAbove: "row"
    }
}).withConfig({
    componentId: "sc-cc912bc-0"
})([
    "width:100%;background-color:",
    ";margin-bottom:",
    ";",
    "{margin-bottom:",
    ";}",
    "{margin-bottom:",
    ";}"
], function(param) {
    var $bannerColor = param.$bannerColor;
    return $bannerColor;
}, getSpacing("3x"), responsiveMediaQueries.desktop, getSpacing("4x"), responsiveMediaQueries.xLargeAndAbove, getSpacing("5x"));
var BannerTextWrapper = styled(Flex).attrs({
    direction: "column",
    justify: "space-between",
    align: "flex-start",
    gap: "3x"
}).withConfig({
    componentId: "sc-cc912bc-1"
})([
    "flex-basis:50%;",
    "{flex-basis:672px;width:672px;}",
    "{padding:",
    ";}",
    "{padding:",
    ";}",
    "{padding:",
    ";}",
    "{padding:",
    ";}"
], responsiveMediaQueries.xxlarge, responsiveMediaQueries.xLargeAndAbove, getSpacing(133, "6x"), responsiveMediaQueries.desktop, getSpacing("10x", "6x"), responsiveMediaQueries.tablet, getSpacing("8x", "4x"), responsiveMediaQueries.mobile, getSpacing("3x", "2x"));
var BannerImageWrapper = styled(Flex).withConfig({
    componentId: "sc-cc912bc-2"
})([
    "flex-basis:50%;",
    "{max-height:176px;}",
    "{flex-basis:100%;}"
], responsiveMediaQueries.mobile, responsiveMediaQueries.xxlarge);
var ContentWrapper = styled(Column).attrs({
    align: "flex-start"
}).withConfig({
    componentId: "sc-cc912bc-3"
})([
    "word-break:break-word;width:100%;",
    "{width:513px;}"
], responsiveMediaQueries.xxlarge);
var BannerImage = styled.img.withConfig({
    componentId: "sc-cc912bc-4"
})([
    "width:100%;object-fit:cover;height:0;min-height:100%;object-position:center;",
    "{height:100%;max-height:176px;}"
], responsiveMediaQueries.mobile);
